
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/events/virtual-events",
      function () {
        return require("private-next-pages/events/virtual-events/index.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/events/virtual-events"])
      });
    }
  